
    export default 
    {
    "select_platform": {
        "title": "Auf welche Plattform möchten Sie zugreifen?"
    }
}